export default {
  ADMIN: 'admin',
  OWNER: 'owner',
  USER: 'user',
}
